(function () {
    require(["jquery"],
        function($) {
            var currentSelectedCell;

            $(document).ready(function() {
                var ulWidth = 0;
                var apiAddress = $("#modulkarta").data("brandapi");

                renderModuleMap(apiAddress);

                //Clear selection
                $('.modulkarta-clear a').on('click',
                    function() {
                        $('.modulkarta-table .selected').removeClass('selected');
                        $('.modulkarta-info .total-price').html('');
                        $('.modulkarta-info .total-desc').html('');
                        currentSelectedCell = null;
                    });
            });

            function unique(a) {
                var isAdded,
                arr = [];
                for (var i = 0; i < a.length; i++) {
                    isAdded = arr.some(function (v) {
                        return isEqual(v, a[i]);
                    });
                    if (!isAdded) {
                        arr.push(a[i]);
                    }
                }
                return arr;
            }

            function isEqual(a, b) {
                var prop;
                for (prop in a) {
                    if (a[prop] !== b[prop]) return false;
                }
                for (prop in b) {
                    if (b[prop] !== a[prop]) return false;
                }
                return true;
            }

            var currentWeekDayFilter = [true, true, true, true, true, true, true];
            
            function filterModuleByWeekDay() {

            }

            function renderModuleMap(url) {
                var currentMediaIndex = 0;
                $('.modulkarta-clear a').hide();
                $('.loader').show();
                $.ajax({
                    type: 'GET',
                    url: url,
                    dataType: 'json',
                    success: function (inData) {
                        if (!((inData != null) && inData.items.length)) {
                            return;
                        }

                        // Ignore any items that probably shouldn't be handled/drawn
                        filteredItems = inData.items.filter(function(x) {
                            if (x.printAreaWidth > 0) {
                                return true;
                            }

                            return false;
                        });

                        inData.items = filteredItems;
                        data = inData;

                        // Find a module map that contains prices. See media Göteborgsposten.
                        currentMediaIndex = findValidModuleMapIndex(data);

                        if (currentMediaIndex >= 0) {
                            $('.loader').hide();
                            $('.modulkarta-clear a').show();
                            drawFilter(currentMediaIndex, data);
                            drawModule(currentMediaIndex, data);
                        }
                        
                        //Filtering by media name
                        $('.modulkarta-info .filter-by-name input[type="radio"]').on('click', function () {
                            for (i = 0; i < data.items.length; i++) {
                                if (i != currentMediaIndex && data.items[i].media.name == $(this).attr('value')) {
                                    drawModule(i, data);
                                    $('.modulkarta-info .total-price').html('');
                                    currentMediaIndex = i;
                                    // filterModuleByWeekDay();
                                    break;
                                }
                            }
                        });

                        //Filtering by media position
                        $('.modulkarta-info .filter-by-position input[type="radio"]').on('click', function () {
                            for (i = 0; i < data.items.length; i++) {
                                if (i != currentMediaIndex && data.items[i].position.name == $(this).attr('value')) {
                                    drawModule(i, data);
                                    $('.modulkarta-info .total-price').html('');
                                    currentMediaIndex = i;
                                    // filterModuleByWeekDay();
                                    break;
                                }
                            }
                        });

                        //Filtering by Weekdays
                        $('.modulkarta-info .filter-by-weekday input[type="checkbox"]').on('click', function () {
                            if ($(this).prop("checked")) {
                                currentWeekDayFilter[parseInt($(this).attr('value'))] = true;
                            } else {
                                currentWeekDayFilter[parseInt($(this).attr('value'))] = false;
                            }

                            if (currentSelectedCell && currentSelectedCell.length > 0) {
                                $(currentSelectedCell[0]).click();
                            }
                            
                            //$('.modulkarta-table .selected').removeClass('selected');
                            //$('.modulkarta-info .total-price').html('');
                            //$('.modulkarta-info .total-desc').html('');
                        });
                    }
                });
            }

            function findValidModuleMapIndex(data) {
                var foundItemIndex = 0;
                var foundItem = false;

                for (i = 0; i < data.items.length; i++) {
                    var modules = data.items[i].modules;
                    
                    if (modules) {
                        for (j = 0; j < modules.length; j++) {
                            var prices = modules[j].prices;
                            var halfPrices = modules[j].pricesHalf;
                            
                            if (prices) {
                                for (k = 0; k < prices.length; k++) {
                                    var currentPrice = prices[k];
                                    
                                    if (currentPrice.price > 0) {
                                        foundItem = true;
                                        break;
                                    }
                                }    
                            }

                            if (halfPrices) {
                                for (k = 0; k < halfPrices.length; k++) {
                                    var currentHalfPrice = halfPrices[k];

                                    if (currentHalfPrice.price > 0) {
                                        foundItem = true;
                                        break;
                                    }
                                }    
                            }

                            if (foundItem) {
                                break;
                            }
                        }
                    }

                    if (foundItem) {
                        break;
                    }

                    foundItemIndex++;
                }

                if (foundItem === false) {
                    return -1;
                }

                return foundItemIndex;
            }

            function drawFilter(currentMediaIndex, data) {
                var htmlName = '';
                var htmlPosition = '';
                var htmlWeekDay = '';
                //7 days a week, could be translated to Swedish if needed, starting from Monday
                var weekDay = ['Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör', 'Sön'];
                var moduleMap = data.items[currentMediaIndex];
                var validWeeekdays = [];

                // Check all prices to see if there are weeekdays that shouldn't be selectable
                for (ix = 0; ix < moduleMap.modules.length; ix++) {
                    var prices = moduleMap.modules[ix].prices;
                    var pricesHalf = moduleMap.modules[ix].pricesHalf;
                    if (prices) {
                        for (var p = 0; p < prices.length; p++) {
                            var weekdays = prices[p].weekdays;

                            if (weekdays) {
                                for (var d = 0; d < weekdays.length; d++) {
                                    var day = weekdays[d];
                                    var hasDay = validWeeekdays.indexOf(d) >= 0;
                                    
                                    if (day && !hasDay) {
                                        validWeeekdays.push(d);
                                    }
                                }
                            }
                        }
                    }
                    if (pricesHalf) {
                        for (var p = 0; p < pricesHalf.length; p++) {
                            var weekdays = pricesHalf[p].weekdays;

                            if (weekdays) {
                                for (var d = 0; d < weekdays.length; d++) {
                                    var day = weekdays[d];
                                    var hasDay = validWeeekdays.indexOf(d) >= 0;
                                    
                                    if (day && !hasDay) {
                                        validWeeekdays.push(d);
                                    }
                                }    
                            }
                        }
                    }
                }

                var count_name = 0;
                var count_position = 0;

                for (i = 0; i < 7; i++) {
                    var disabledProp = "";
                    var isValidWeekday = validWeeekdays.indexOf(i) >= 0;
                    if (!isValidWeekday) {
                        disabledProp = " disabled";
                    }

                    htmlWeekDay += '<div class="check-box"><input' + disabledProp + ' type="checkbox" checked="checked" id="date-' + i + '" value="' + i + '"><label for="date-' + i + '">' + weekDay[i] + '</label></div>';
                }

                var mediaArray = [];
                var positionArray = [];
                for (i = 0; i < data.items.length; i++) {
                    mediaArray.push({ id: data.items[i].media.id, name: data.items[i].media.name });
                    positionArray.push(data.items[i].position.name);
                }
                mediaArray = unique(mediaArray);
                positionArray = unique(positionArray);
                //Build media name filter
                for (i = 0; i < mediaArray.length; i++) {
                    count_name += 1;
                    htmlName += '<div class="radio-box"><input type="radio" name="media-name" id="media-' + mediaArray[i].id + '" value="' + mediaArray[i].name + '"><label for="media-' + mediaArray[i].id + '">' + mediaArray[i].name + '</label></div>';
                }

                //Inject all HTML to the placeholder, set the first item to be selected
                if (count_name >= 1) {
                    $('.modulkarta-info .filter-by-name').html('<h3>Medie</h3>' + htmlName);
                    $('.modulkarta-info .filter-by-name input:first').prop('checked', true);
                }

                //weekdays
                $('.modulkarta-info .filter-by-weekday').html('<h3>Veckodagar</h3>' + htmlWeekDay);

            }

            function drawModule(index, data) {
                moduleMap = data.items[index];
                var html = '';
                var total_cel_amount = moduleMap.modules.length;
                var total_col_amount = moduleMap.columnWidths.length;
                var total_row_amount = moduleMap.rowHeights.length;
                var cel_width = 100 / total_col_amount;//in percentage
                var cel_height;//in pixel
                var cel_ratio;
                var disabled_class = '';
                var cel_data_row;

                for (i = 0; i < total_cel_amount; i++) {
                    cel_data_row = Math.floor(i / total_col_amount);
                    cel_ratio = moduleMap.rowHeights[cel_data_row] / moduleMap.columnWidths[0];
                    cel_height = 80 * cel_ratio;

                    var previouslyDisabled = false;

                    //Check disabled class
                    if (!moduleMap.modules[i].allowAd) {
                        disabled_class = ' disabled';
                        previouslyDisabled = true;
                    } else {
                        disabled_class = ' selectable';
                    }

                    var hasValidPrices = false;
                    var prices = moduleMap.modules[i].prices;
                    var pricesHalf = moduleMap.modules[i].pricesHalf;

                    if (moduleMap.modules[i].allowHalf) {
                        for (ix = 0; ix < pricesHalf.length; ix++) {
                            var currentPrice = pricesHalf[ix].price;                        
                            if (currentPrice > 0) {
                                hasValidPrices = true;
                            }
                        }
    
                        if (!hasValidPrices && !previouslyDisabled) {
                            disabled_class = ' disabled';
                        } else {
                            disabled_class = ' selectable';
                        }

                        html += '<div class="cell" style="width:' + cel_width + '%;height:' + cel_height + 'px">';
                        html += '<div class="half-inner-cell cell-target' + disabled_class + '"';
                        html += ' style="height:' + cel_height / 2 + 'px;"';
                        html += ' data-index="' + index + '" data-label="' + moduleMap.modules[i].labelHalf + '">';
                        html += '<h4>' + moduleMap.modules[i].labelHalf + '</h4>';
                        html += '<p>' + moduleMap.modules[i].textHalf + '</p>';
                        html += '</div>';

                        hasValidPrices = false;

                        for (ix = 0; ix < prices.length; ix++) {
                            var currentPrice = prices[ix].price;
                            if (currentPrice > 0) {
                                hasValidPrices = true;
                            }
                        }

                        if (!hasValidPrices && !previouslyDisabled) {
                            disabled_class = ' disabled';
                        } else {
                            disabled_class = ' selectable';
                        }  

                        html += '<div class="half-inner-cell cell-target' + disabled_class + '"';
                        html += ' style="height:' + cel_height / 2 + 'px;"';
                        html += ' data-index="' + index + '" data-label="' + moduleMap.modules[i].label + '">';
                        html += '<h4>' + moduleMap.modules[i].label + '</h4>';
                        html += '<p>' + moduleMap.modules[i].text + '</p>';
                        html += '</div>';
                        html += '</div>';
                    } else {
                        for (ix = 0; ix < prices.length; ix++) {
                            var currentPrice = prices[ix].price;
                            if (currentPrice > 0) {
                                hasValidPrices = true;
                            }
                        }

                        if (!hasValidPrices && !previouslyDisabled) {
                            disabled_class = ' disabled';
                        }

                        html += '<div class="cell" style="width:' + cel_width + '%;height:' + cel_height + 'px"><div class="inner-cell cell-target' + disabled_class + '"';
                        html += ' data-index="' + index + '" data-label="' + moduleMap.modules[i].label + '">';
                        html += '<h4>' + moduleMap.modules[i].label + '</h4>';
                        html += '<p>' + moduleMap.modules[i].text + '</p>';
                        html += '</div></div>';
                    }
                }

                $('.modulkarta-table').html(html);

                // Select a module
                $('.selectable').on('click', function () {
                    $('.selected').removeClass('selected');
                    //Set the current cell to be selected
                    $(this).addClass('selected');
                    var selected_cell = $(this);
                    currentSelectedCell = selected_cell;
                    //Set all related cells to be selected
                    $('.cell-target').each(function () {
                        if ($(this).position().top >= selected_cell.position().top && $(this).position().left <= selected_cell.position().left) {
                            $(this).addClass('selected');
                        }
                    });

                    var total_price_html = '<h3>Vald modul</h3>';
                    var selectedModule = data.items[selected_cell.data('index')].modules;
                    var selectedPrice = [];
                    if (selected_cell.data('label').length > 2) {
                        //Half module
                        for (i = 0; i < selectedModule.length; i++) {
                            if (selectedModule[i].labelHalf == selected_cell.data('label')) {
                                selectedPrice = selectedModule[i].pricesHalf.slice();
                                break;
                            }
                        }
                    } else {
                        //Normal module
                        for (i = 0; i < selectedModule.length; i++) {
                            if (selectedModule[i].label == selected_cell.data('label')) {
                                selectedPrice = selectedModule[i].prices.slice();
                                break;
                            }
                        }
                    }

                    total_price_html += '<p><span>Storlek:</span> ' + selected_cell.find('h4').text() + '</p>';
                    var wholeWeek = true;

                    for (i = 0; i < selectedPrice.length; i++) {
                        for (j = 0; j < selectedPrice[i].weekdays.length; j++) {
                            if (selectedPrice[i].weekdays[j] === false) {
                                wholeWeek = false;
                                break;
                            }
                        }
                        if (wholeWeek) {
                            total_price_html += '<p><span>' + selectedPrice[i].position + ' - applicerad för alla veckodagar:</span> ' + selectedPrice[i].price + ' <span>kr</span></p>';
                        } else {
                            var weekDay = ['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag', 'Söndag'];
                            var week_day_text = [];

                            for (j = 0; j < 7; j++) {
                                if (currentWeekDayFilter[j] === true && selectedPrice[i].weekdays[j] === true && wholeWeek === false) {
                                    week_day_text.push(weekDay[j]);
                                }
                            }
                            if (week_day_text.length > 0) {
                                total_price_html += '<p><span>' + selectedPrice[i].position + ' - ' + week_day_text.toString().replace(/,/g, ", ") + ':</span> ' + selectedPrice[i].price + ' <span>kr</span></p>';
                            }

                        }

                    }


                    $('.modulkarta-info .total-price').html(total_price_html);

                });
            }

            function checkArr(arr) {
                var x = true;
                for (i = 0; i < arr.length - 1; i++) {
                    if (arr[i + 1] != arr[i]) {
                        x = false;
                    }
                }
                return x;
            }

            function checkArrNull(arr) {
                var x = true;
                for (i = 0; i < arr.length; i++) {
                    if (arr[i] === null || arr[i] === 'null' || arr[i] === undefined || arr[i] === "") {
                        x = false;
                    }
                }
                return x;
            }
        });

}).call(this);

define("commons/modulemap", function(){});

